import { render, staticRenderFns } from "./ResetExamEditor.vue?vue&type=template&id=d3f62480&scoped=true&"
import script from "./ResetExamEditor.vue?vue&type=script&lang=js&"
export * from "./ResetExamEditor.vue?vue&type=script&lang=js&"
import style0 from "./ResetExamEditor.vue?vue&type=style&index=0&id=d3f62480&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f62480",
  null
  
)

export default component.exports